"use client"
import React, { useEffect, useState } from 'react';
import {
  ScissorsIcon,
  Bars3Icon,
  XMarkIcon,
  } from "@heroicons/react/24/outline";

const Navbar: React.FC = () => {
  const [toggleMenu, setToggleMenu] = useState(false);
  const [selectedItem, setSelectedItem] = useState("home")
  const [isScrolled, setIsScrolled] = useState(false);
  
  const navItems = [
      { id: "home", label: "POČETNA" },
      { id: "services", label: "USLUGE" },
      { id: "gallery", label: "GALERIJA" },
      { id: "testimonials", label: "UTISCI" },
      { id: "contact", label: "KONTAKT" }
  ];

  // Effect to toggle body scroll
  useEffect(() => {
      if (toggleMenu) {
      document.body.style.overflow = "hidden";
      } else {
      document.body.style.overflow = "auto";
      }
      return () => {
      document.body.style.overflow = "auto";
      };
  }, [toggleMenu]);

  useEffect(() => {
      const handleScroll = () => {
          setIsScrolled(window.scrollY > 0);
      };

      window.addEventListener("scroll", handleScroll);
      return () => {
          window.removeEventListener("scroll", handleScroll);
      };
  }, []);

  const handleScroll = (id: string, flag: boolean) => {
    const section = document.getElementById(id);
    if (section) {
      section.scrollIntoView({
        behavior: flag ? "auto" : "smooth",
        block: "start",
        inline: 'start'
      });
    }
    setSelectedItem(id);
    setToggleMenu(false);
  };

  useEffect(() => {
    if (toggleMenu) return
    // Create an IntersectionObserver to monitor the visibility of sections
    const sections = navItems.map(item => document.getElementById(item.id));

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            const id = entry.target.id;
            setSelectedItem(id); // Update selected item based on visible section
          }
        });
      },
      { threshold: [0.5, 0.2] } // Trigger when at least 50% of the section is visible
    );

    sections.forEach(section => {
      if (section) observer.observe(section);
    });

    return () => {
      sections.forEach(section => {
        if (section) observer.unobserve(section);
      });
    };
  }, [navItems]);

  return (
    <nav className={`fixed z-50 w-full bg-white shadow-md ${isScrolled ? "bg-white text-gray-900" : "bg-transparent text-white"}`} 
                style={{ backgroundColor: 'white', fontSize: '1.3rem', color: 'white', fontFamily: '"Barlow Condensed", sans-serif', fontWeight: 600 }}>
            <div className={`${isScrolled ? "bg-white text-gray-900 lg:py-0 md:py-2 sm:py-2" : "bg-transparent text-white"}`} style={{ position: 'absolute', width: '100%', paddingInline: '15%', left: 0, right: 0, margin: "0 auto" }}>
            <div className="flex">
                {/* Primary menu and logo */}
                <div style={{ width: '100%' }} className={`flex items-center justify-between ${isScrolled ? "" : "my-8"} mr-12`}>
                {/* logo */}
                <div>
                    <a
                    href="/"
                    className="flex gap-1 font-bold text-gray-700 items-center "
                    >
                      {isScrolled ? 
                    <img id='logo' src='/images/icon-black.svg' width={80} style={{ marginRight: '20px' }}/> : 
                    <img id='logo' src='/images/icon.svg' width={80} style={{ marginRight: '20px' }}/> }
                    <span id='storeName' style={{ color: isScrolled ? "black" : "white", textTransform: 'uppercase', fontSize: '1.6rem'}}>Berberaj032</span>
                    </a>
                </div>
                {/* primary */}
                <div
                className="hidden lg:flex flex-col lg:flex-row gap-8 p-4 lg:p-0 bg-gray-900 lg:bg-transparent"
                >
                    {navItems.map((item) => (
                        <a
                            key={item.id}
                            href={`#${item.id}`}
                            onClick={() => { 
                              handleScroll(item.id, false);
                              setTimeout(() => handleScroll(item.id, false), 50);                              
                              setToggleMenu(false);
                            }}
                            className={`navitem ${selectedItem === item.id ? "" : ""}`}
                            style={{
                                color: selectedItem === item.id ? '#bf925b' : isScrolled ? "black" : "white",
                            }}
                        >
                            {item.label}
                        </a>
                    ))}
                </div>
                </div>
                {/* secondary */}
                <div className="flex gap-6">
                {/* Mobile navigation toggle */}
                <div className="lg:hidden flex items-center z-50">
                    <button onClick={() => setToggleMenu(!toggleMenu)}>
                    {!toggleMenu ? 
                        <Bars3Icon className="h-6" /> 
                        : <XMarkIcon className="closeIcon"/>
                    }
                    </button>
                </div>
                </div>
            </div>
            </div>
            {/* mobile navigation */}
            <div
            className={`fixed z-40 w-full  bg-gray-100 overflow-hidden flex flex-col lg:hidden gap-12  origin-top duration-700 ${
                !toggleMenu ? "h-0" : "h-100"
            }`}
            >
                <div className="px-8 mt-5">
                    <div className="flex flex-col gap-8 font-bold tracking-wider">
                        {navItems.map((item) => (
                            <a
                                key={item.id}
                                href="#"
                                onClick={() => {
                                  handleScroll(item.id, true);
                                  setTimeout(() => handleScroll(item.id, true), 50);                              
                                  setToggleMenu(false);
                                }}
                                className={`${
                                    selectedItem === item.id ? "border-l-4 border-gray-600 pl-2" : ""
                                }`}
                                style={{
                                    color: selectedItem === item.id ? '#bf925b' : 'black',
                                    borderColor: selectedItem === item.id ? '#bf925b' : 'black'
                                }}
                            >
                                {item.label}
                            </a>
                        ))}
                    </div>
                </div>
            </div>
        </nav>
  );
};

export default Navbar;

